(function (appComponents) {

	appComponents.controllers.orderCheckout = function (Components) {
		var orderCheckout = {};

		orderCheckout.name = "orderCheckout";

		// 1. type
		// 2. method
		// 3. carrier

		Components.getControllerPrototype().extend(orderCheckout);

		orderCheckout._cart = orderCheckout._getService("cartBase");
		orderCheckout._modals = orderCheckout._getService("modals");
		orderCheckout._helpers = orderCheckout._getService("helpers");
		orderCheckout._product = orderCheckout._getService("productBase");
		orderCheckout._b2bUnit = orderCheckout._getService("b2bUnit");
		orderCheckout._orders = orderCheckout._getService("ordersBase");
		orderCheckout._checkoutProfileBase = orderCheckout._getService("checkoutProfileBase");
		orderCheckout._customerRating = orderCheckout._getService("customerRating");
		orderCheckout._cartCheckout = orderCheckout._getService("cartCheckout");
		orderCheckout.shippingCollection = orderCheckout._getPageComponent("shippingCollection");
		orderCheckout.reviewCollection = orderCheckout._getPageComponent("reviewCollection");

		orderCheckout.firstStepData = {};
		orderCheckout.stepRunning = false;

		orderCheckout.elements = {

			get shippingAddresses() {
				return $('[pc-container="order-checkout--shipment-addresses-selector"]');
			},
			get addShippingModal() {
				return $('[pc-container="order-checkout--add-shipping-modal"]');
			},
			get addThirdPartyModal() {
				return $('[pc-container="order-checkout--add-third-party-billing-modal"]');
			},
			get thirdPartyAddresses() {
				return $('[pc-container="order-checkout--third-party-billing-selector"]');
			},
			get thirdPartyAddressesModal() {
				return $('[pc-container="order-checkout--modal-third-party-address"]');
			},
			get goToShippingAcc() {
				return $('[pc-container="order-checkout--go-to-shipping-acc"]');
			},
			get goToReviewAcc() {
				return $('[pc-container="order-checkout--go-to-review-acc"]');
			},
			get goToConfirmAcc() {
				return $('[pc-container="order-checkout--go-to-confirm-acc"]');
			},
			get reviewStepBody() {
				return $('[pc-container="order-checkout--step-review-entries"]');
			},
			get confirmStepBody() {
				return $('[pc-container="order-checkout--step-confirm-body"]');
			},
			get saveOrderBtn() {
				return $('[pc-container="order-checkout--save-order-btn"]');
			},
			get cancelOrderBtn() {
				return $('[pc-container="order-checkout--cancel-order-btn"]');
			},
			get checkoutProfileInput() {
				return $('[pc-container="order-checkout--checkout-profile-input"]');
			},
		};

		orderCheckout.bindings = function () {
			
			orderCheckout._elements.page.on("click", "[pc-container='order-checkout--save-order-btn']", function () {
				orderCheckout.handlers.onSaveOrder();
			});
			orderCheckout._elements.page.on("click", "[pc-container='order-checkout--cancel-order-btn']", function () {
				orderCheckout.handlers.onCancelOrder();
			});
			orderCheckout._elements.page.on("change", "[pc-container='order-checkout--checkout-profile-selector']", function () {
				orderCheckout.handlers.onApplyProfile(this.value);
			});
			orderCheckout._elements.page.on("change", "[pc-container='order-checkout--shipment-type-selector']", function () {
				var type = $(this).val();
				var pk = $(this).parents('[pc-container="order-checkout--item"]').attr("pc-value");
				orderCheckout.shippingCollection.findItemByPk(pk).updateMethods(type);
				$("#order-checkout--shipment-type-selector +span").removeClass("pc-error-field");
			});
			orderCheckout._elements.page.on("change", "[pc-container='order-checkout--shipment-method-selector']", function () {
				var method = $(this).val();
				var pk = $(this).parents('[pc-container="order-checkout--item"]').attr("pc-value");
				orderCheckout.shippingCollection.findItemByPk(pk).updateCarriers(method);
			});
			orderCheckout._elements.page.on("change", "[pc-container='order-checkout--shipment-carrier-selector']", function () {
				var carrier = $(this).val();
				var pk = $(this).parents('[pc-container="order-checkout--item"]').attr("pc-value");
				orderCheckout.shippingCollection.findItemByPk(pk).checkIfCarrierSelected(carrier);
			});
			orderCheckout._elements.page.on("change", "[pc-container='order-checkout--shipment-addresses-selector']", function (e, ignoreEvent) {
				if (ignoreEvent) return;
				var addressId = $(this).val();
				var pk = $(this).parents('[pc-container="order-checkout--item"]').attr("pc-value");
				orderCheckout.shippingCollection.assignShippingAddressToEntry(pk, addressId);
			});
			orderCheckout._elements.page.on("change", "[pc-container='order-checkout--third-party-billing-selector']", function () {
				var addressId = $(this).val();
				var pk = $(this).parents('[pc-container="order-checkout--item"]').attr("pc-value");
				orderCheckout.shippingCollection.findItemByPk(pk).assignThirdPartyAddress(addressId);
			});
			orderCheckout._elements.page.on("click", "[pc-container='order-checkout--open-add-shipping-address-btn']", function () {
				var pk = $(this).parents('[pc-container="order-checkout--item"]').attr("pc-value");
				$('#wby-drop-country').prop('selectedIndex', 0).trigger("change");
				orderCheckout.shippingCollection.findItemByPk(pk).setShippingAddressDataToModal();
			});
			orderCheckout._elements.page.on("click", "[pc-container='order-checkout--open-add-third-party-address-btn']", function () {
				var pk = $(this).parents('[pc-container="order-checkout--item"]').attr("pc-value");
				orderCheckout.shippingCollection.findItemByPk(pk).setThirdPartyAddressDataToModal();
			});
			orderCheckout._elements.page.on("submit", "[pc-container='order-checkout--add-shipping-address-form']", function () {
				orderCheckout.handlers.onShippingAddressSubmit(this);
				return false;
			});
			orderCheckout._elements.page.on("submit", "[pc-container='order-checkout--add-third-party-billing-form']", function () {
				orderCheckout.handlers.onThirdPartyAddressSubmit(this);
				return false;
			});
			orderCheckout._elements.page.on("click", "[pc-container='order-checkout--remove-third-party-address']", function () {
				var thirdPartyAddressId = $(this).parent().closest('[pc-container="order-checkout--item-modal-third-party-address"]').attr("pc-value");
				orderCheckout.handlers.onThirdPartyAddressRemove(thirdPartyAddressId);
			});
			orderCheckout._elements.page.on("click", '[pc-container="order-checkout--item-datapack"]', function () {
				var pk = $(this).parent().closest('[pc-container="order-checkout--review-item"]').attr("pc-value");
				var type = $(this).attr("pc-value");
				orderCheckout.handlers.onDataPackItemClick(pk, type);
			});
			orderCheckout._elements.page.on("click", "[pc-container='order-checkout--go-to-shipping-btn']", function () {
				var form = $('[pc-container="order-checkout--bill-to-form"]')[0];
				orderCheckout.handlers.onGoToShipping(form);
				$(".order-submit").attr("disabled",false);
			});
			  orderCheckout._elements.page.on("click", "[pc-container='order-checkout--go-to-review-btn']", function () {
				orderCheckout.handlers.onGoToReview();
				$(".order-submit").attr("disabled",false)
			});
			orderCheckout._elements.page.on("click", "[pc-container='order-checkout--go-to-confirm-btn']", function () {
				$(this).attr("disabled", true);
				orderCheckout.handlers.onGoToConfirm();
			});

			// from td
			orderCheckout._elements.page.on('ifChecked', 'input[name="condition"]', function (e) {
				if ($(this).val() == 'condition-yes') {
					orderCheckout._modals.error.show(orderCheckout._messages.nuclearWarning);
				}
				if ($(this).val() == 'condition-no') {
					$('.no-cart-btn').addClass('dis-none');
					$('.yes-cart-btn').addClass('dis-none');
					$('.disclaimer-condition').addClass('dis-none');
					$('.quote-panel').removeClass('dis-none');
					$('.back-cart-btn').removeClass('dis-none');
					$('.save-odr-btn').removeClass('dis-none');
					$('.submit-modal-btn').removeClass('dis-none');
					$('.no-cart-btn').addClass('dis-none');
					$(".wizard-bill").addClass('acc-wizard-active');
				}
			});

			orderCheckout._elements.page.on('ifChecked', "[pc-container='order-checkout--apply-to-all-checkbox']", function (event) {
				var id = event.target.id;
				//console.log("checkbox id log================================="+id);
				var sel = $("#" +id).parent().parent().parent().parent().find( "select[name='shippingId']" ).val();
				var tex = $("#" +id).parent().parent().parent().parent().find( "select[name='shippingId'] option:selected" ).text();
				var selForShipPayType = $("#" +id).parent().parent().parent().parent().find( "select[name='shipmentType']" ).val();
				var texForShipPayType = $("#" +id).parent().parent().parent().parent().find( "select[name='shipmentType'] option:selected" ).text();
				$("select[name='shippingId']").each(function( index ) {
			         if ( $( this ).find('option:contains('+ tex +')').length <= 0 )       {//id = customAddress	
			        	 $( this ).append($('<option></option>').val("customAddress").html(tex));
			         }

				});
				$("select[name='shippingId']").val(sel).trigger("change");
					if ($('#' + id).is(':checked') ){
						$("[pc-container='order-checkout--apply-to-all-checkbox']").attr("disabled", true).parent().addClass("disabled-checkbox");
						$("#" +id).removeAttr("disabled").parent().removeClass("disabled-checkbox");
					}
				//console.log("after trigerring log=================================");
				
				$("select[name='shipmentType']").val(selForShipPayType).trigger("change");
				if ($('#' + id).is(':checked') ){
					$("[pc-container='order-checkout--apply-to-all-checkbox']").attr("disabled", true).parent().addClass("disabled-checkbox");
					$("#" +id).removeAttr("disabled").parent().removeClass("disabled-checkbox");
				}
				//console.log("after trigerring log=================================");
				});
			orderCheckout._elements.page.on('ifUnchecked', "[pc-container='order-checkout--apply-to-all-checkbox']", function (event) {
					//console.log("checkbox event log=================================");
					// $("select[name='shippingId']").val("").trigger("change");
					// $("select[name='shipmentType']").val("Please Select").trigger("change");
					$("[pc-container='order-checkout--apply-to-all-checkbox']").removeAttr("disabled").parent().removeClass("disabled-checkbox");
				
				});

			// from thinkdesign core
			orderCheckout._elements.page.off("click", '.show-more-less-order').on("click", '.show-more-less-order', function () {
				$(this).closest('.review-body').find('.hidden-row').toggleClass('dis-none');
				$(this).closest('.hidden-panel').find('.hidden-row').toggleClass('dis-none');
				if ($(this).text() == "Show More")
					$(this).text("Show Less");
				else
					$(this).text("Show More");
			});

			orderCheckout._elements.page.off('click', '.acc-wizard-todo>a').on('click', '.acc-wizard-todo>a', function (e) {
				e.preventDefault();
			});

			orderCheckout._elements.page.off('click', "[pc-container='order-checkout--save-checkout-profile']").on("click", "[pc-container='order-checkout--save-checkout-profile']", function () {

				orderCheckout.handlers.onSaveCheckoutProfile();
			});

			orderCheckout._elements.page.off('click', ".checkout-href").on("click", ".checkout-href", function () {

				$('.hidden-checkout').removeClass('dis-none');
			});


			orderCheckout._elements.page.on("ifChecked", "[pc-container='order-checkout--accept-btn']", function () {
				$(".review-sub, .submit-modal-btn").removeClass('disabled disabled-btn').addClass('btn-primary');
			});


			orderCheckout._elements.page.on('ifUnchecked', "[pc-container='order-checkout--accept-btn']", function () {
				$(".review-sub, .submit-modal-btn").addClass('disabled disabled-btn').removeClass('btn-primary');
			});

		};

		orderCheckout.liveBindings = function () {
			$(".order-checkout-calendar").on("click",function(){
				var datePicker= $(this).attr('value') ;
				$("#order-checkout-shipDate-"+datePicker).focus();
				
			});
			$('body').on('click', '.dropship-close-btn', function(e){
				/*$("#add_err_msg_name").hide();
         	   $("#add_err_msg_name").remove();
         	   $("#name").removeClass("pc-error-field");
         	   $("#add_err_msg_address").hide();
         	   $("#address").removeClass("pc-error-field");
         	   $("#add_err_msg_city").hide();
         	   $(".zip-code-pty").removeClass("pc-error-field");
         	   $(".city-pty").removeClass("pc-error-field");*/
         	   $('#wby-drop-country').prop('selectedIndex', 0).trigger("change");
			});
			
			$('body').on('click', '.footer-checkout', function(e) {
//				orderCheckout.handlers.disableHeaderAndFooter();
				var quoteRefNumber = $(".referenceQuoteNumber").text();
				if(quoteRefNumber != "" && quoteRefNumber != undefined && quoteRefNumber != null) {
					orderCheckout._modals.warning.showquoteToCartWarningMessage();
					e.preventDefault();
					return false;
				}
			});
			
			$("ul.footer-nav li").click(function(e) {
				var quoteRefNumber = $(".referenceQuoteNumber").text();
				if(quoteRefNumber != "" && quoteRefNumber != undefined && quoteRefNumber != null) {
					orderCheckout._modals.warning.showquoteToCartWarningMessage();
					e.preventDefault();
					return false;
				}
			});
			
			$(".navbar-fixed-top").click(function(e) {
				var quoteRefNumber = $(".referenceQuoteNumber").text();
				if(quoteRefNumber != "" && quoteRefNumber != undefined && quoteRefNumber != null) {
					orderCheckout._modals.warning.showquoteToCartWarningMessage();
					e.preventDefault();
					return false;
				}
			});
			
			$(".footer-links").click(function(e) {
				var quoteRefNumber = $(".referenceQuoteNumber").text();
				if(quoteRefNumber != "" && quoteRefNumber != undefined && quoteRefNumber != null) {
					orderCheckout._modals.warning.showquoteToCartWarningMessage();
					e.preventDefault();
					return false;
				}
			});
			
			$('body').on('click', '.proceedToCheckoutBtn', function(e) {
				$(".close-modal-icon").trigger("click");
			});
			
			$('body').on('click', '.cancel-order-popup', function(e) {
				$(".close-modal-icon").trigger("click");
				orderCheckout.handlers.onCancelOrder();
			});
			
			// from thinkdesign core
			$('.quick-check-dd').hide();
			$('.bill-info').on('ifChanged', function () {
				$('.quick-check-dd').show();
			});

			$(".bill-check").click(function () {
				$(this).parents(".panel-default").find(".circle-gray").addClass("active").html("<i class='fa fa-check'></i>");
				$(".wizard-bill").addClass("active");
				$("#ship-heading").find(".circle-gray").addClass("active");
			});
			$(".shipping-check").click(function () {
				$(this).parents(".panel-default").find(".circle-gray").addClass("active").html("<i class='fa fa-check'></i>");
				$(".wizard-ship").addClass("active");
				$("#review-heading").find(".circle-gray").addClass("active");
			});
			$(".review-check").click(function () {
				$(this).parents(".panel-default").find(".circle-gray").addClass("active").html("<i class='fa fa-check'></i>");
				$(".wizard-review").addClass("active");
				$("#confirm-heading").find(".circle-gray").addClass("active");
			});

		};

		orderCheckout.populateInitialContext = function () {
			var defToReturn = $.Deferred();

			var defTypes = orderCheckout.populateShipmentTypes();
			var defThirdPartyBills = orderCheckout.populateThirdPartyAddresses();
			var defShipping = orderCheckout.populateShippingAddresses();
			var defBilling = orderCheckout.populateBillingAddresses();
			var defProfiles = orderCheckout.populateCheckoutProfiles();

			orderCheckout.context.cartData = orderCheckout._cart.cartData;
			orderCheckout.context.entries = orderCheckout._cart.cartData.entries;
			orderCheckout.context.kits = orderCheckout._cart.cartKits;
			orderCheckout.context.minimumOrderAmount = orderCheckout._cart.minimumOrderAmount;


			orderCheckout.context.unit = orderCheckout._b2bUnit.currentUnit;
			orderCheckout.context.unitType = orderCheckout._b2bUnit.currentUnit.unitType;

			$.when(defTypes, defThirdPartyBills, defShipping, defBilling, defProfiles).then(function () {
				defToReturn.resolve();
			});

			return defToReturn;
		};

		orderCheckout.populateCheckoutProfiles = function () {
			return orderCheckout._checkoutProfileBase.getProfiles().then(function (profiles) {
				if (profiles) {
					orderCheckout.context.checkoutProfiles = profiles;
				}
			});
		};

		orderCheckout.populateBillingAddresses = function () {
			return orderCheckout._api.b2bUnit.getBillingAddresses().then(function (res) {
				if (res && res.status == 200) {
					orderCheckout.context.billingAddresses = res.body;
				}
			}).fail(function (e) {
				console.log(e);
			});
		};

		orderCheckout.populateShippingAddresses = function () {
			return orderCheckout._api.b2bUnit.getShippingAddresses().then(function (res) {
				if (res && res.status == 200) {
					orderCheckout.context.shippingAddresses = res.body;
				} else {
					console.log(res);
				}
			});
		};

		orderCheckout.populateThirdPartyAddresses = function () {
			return orderCheckout._api.orderCheckout.getThirdPartyAddresses().then(function (res) {
				if (res && res.status == 200) {
					orderCheckout.context.thirdPartyAddresses = res.body.thirdPartyAddress;
				} else {
					console.log(res);
				}
			});
		};

		orderCheckout.populateShipmentTypes = function () {
			return orderCheckout._api.orderCheckout.getShipmentTypes().then(function (res) {
				if (res && res.status == 200) {
					orderCheckout.context.shipmentTypes = res.body;
				} else {
					console.log(res);
				}
			});
		};

		orderCheckout.initCheckout = function () {
			return orderCheckout._api.orderCheckout.initCheckout();
		};

		orderCheckout.renderReviewStep = function () {
			var html = orderCheckout.templates.entryReview(orderCheckout.context);
			orderCheckout.elements.reviewStepBody.html(html);
		};

		orderCheckout.renderConfirmStep = function () {
			var html = orderCheckout.templates.confirmStepBody(orderCheckout.context);
			orderCheckout.elements.confirmStepBody.html(html);
		};

		orderCheckout.renderThirdPartyAddresses = function () {
			var html = orderCheckout.templates.thirdPartyAddresses(orderCheckout.context);
			orderCheckout.elements.thirdPartyAddresses.html(html);
			html = orderCheckout.templates.thirdPartyAddressesModal(orderCheckout.context);
			orderCheckout.elements.thirdPartyAddressesModal.html(html);
		};

		orderCheckout.updateShippingAddresses = function () {
			return orderCheckout.populateShippingAddresses().then(function () {
				var html = orderCheckout.templates.shippingAddresses(orderCheckout.context);
				orderCheckout.elements.shippingAddresses.html(html);
			});
		};

		orderCheckout.updateThirdPartyAddresses = function () {
			return orderCheckout.populateThirdPartyAddresses().then(function () {
				orderCheckout.renderThirdPartyAddresses();
			});
		};

		orderCheckout.checkIfTermsAndConditionsChecked = function () {
			var box = $("#checkbox");
			if (box.is(":checked")) {
				box.closest(".icheckbox_square-blue").removeClass("pc-error-field");
				return true;
			} else {
				box.closest(".icheckbox_square-blue").addClass("pc-error-field");
				orderCheckout._modals.warning.show(orderCheckout._messages.checkoutConfirmTerms);
				return false;
			}
		};
		
		orderCheckout.hideCartSizeWidget = function() {
			var quoteRefNumber = $(".referenceQuoteNumber").text();
			if(quoteRefNumber != "" && quoteRefNumber != undefined && quoteRefNumber != null) {
				orderCheckout._cart.hideCartSizeWidget();
			}
		};
		
		orderCheckout.showCartSizeWidget = function() {
			orderCheckout._cart.showCartSizeWidget();
		};

		orderCheckout.handlers = {
			onApplyProfile: function (code) {
				orderCheckout._checkoutProfileBase.applyProfile(code).then(function (isApplied) {
					if (isApplied) {
						orderCheckout.init().then(function () {
							setTimeout(function () {
								orderCheckout._modals.success.show(orderCheckout._messages.checkoutProfile.profileApplied);
							}, 500);
						});
					} else {
						orderCheckout._modals.error.show(orderCheckout._messages.checkoutProfile.serverError);
					}
				});
			},
			onSaveCheckoutProfile: function () {
				var data = {
					orderNumber: orderCheckout.context.order.code,
					profileName: orderCheckout.elements.checkoutProfileInput.val()
				};

				orderCheckout._api.checkoutProfile.saveOrderAsProfile(data).then(function (res) {
					if (res && res.status == 200) {
						orderCheckout._goToPage("checkoutProfile");
					} else {
						orderCheckout._modals.error.show(res.message);
					}
				});
			},
			onB2bUnitChanged: function () {
				if (orderCheckout._isActiveController) {
					orderCheckout.init();
				}
			},
			onSaveOrder: function () {
				orderCheckout._api.orderCheckout.saveOrder().then(function (res) {
					if (res && res.status == 200) {
						orderCheckout._events.dispatchEvent("orderCreated");
						orderCheckout._modals.success.show(orderCheckout._messages.orderSaved);
						setTimeout(function () {
							orderCheckout._goToPage("index");
						}, 2000);
						return;
					}
				});
			},
			onCancelOrder: function () {
				orderCheckout._api.orderCheckout.cancelOrder().then(function (res) {
					if (res && res.status == 200) {
						console.log("Order Cancelled...");
						orderCheckout._cart._stash.cart.size = res.body.CART_SIZE;
						orderCheckout._cart.updateWidget();
						orderCheckout._modals.success.show(orderCheckout._messages.orderCancelled);
						setTimeout(function () {
							orderCheckout.showCartSizeWidget();
							orderCheckout._goToPage("index");
						}, 2000);
						return;
					}
				});
			},
			disableHeaderAndFooter: function () {
				var quoteRefNumber = $(".referenceQuoteNumber").text();
				if(quoteRefNumber != "" && quoteRefNumber != undefined && quoteRefNumber != null) {
					orderCheckout._modals.warning.showquoteToCartWarningMessage();
					e.preventDefault();
					return false;
				}
			},
			onDataPackItemClick: function (pk, type) {
				orderCheckout.reviewCollection.findItemByPk(pk).downloadDataPack(type);
			},
			onShippingAddressSubmit: function (form) {
				//var isCanada = orderCheckout._helpers.checkCandadaCustomers(form);
				var hasErrors = orderCheckout._helpers.checkFormForErrors(form);
				/* removed logic for canadian orders
				 if(isCanada)
					{
					orderCheckout._modals.error.show(orderCheckout._messages.blockCanOrderError);
					return;
					}
				else*/ 
				if (hasErrors) {
					orderCheckout._modals.error.show(orderCheckout._messages.formError);
					return;
				}
				/*var regex_add_error = false;
				var name_error = false;
				var address_error = false;
				var city_error = false;
				
	               var regex_name =  /^[a-zA-Z0-9\, -]+$/;
	               var name = $(form).find("#name").val();
	              var address = $(form).find("#address").val();
	              var city = $(form).find(".city-pty").val();
	              var zip = $(form).find(".zip-code-pty").val();
	             
	               if (!regex_name.test(name)) {
	            	   name_error = true;
	            	   $("#name").addClass("pc-error-field");
	            	   $("#add_err_msg_name").show();
	            	   
	            	   if(!address_error){
	            		   $("#add_err_msg_address").hide();
	            	   } else {
	            		   $("#add_err_msg_address").show();
	            	   }
	            	   
	            	   if(!city_error){
	            		   $("#add_err_msg_city").hide();  
	            	   } else {
	            		   $("#add_err_msg_city").show();
	            	   }
	            	   regex_add_error = true;
	               }
	                if (!regex_name.test(address)) {
	                	address_error = true;
	                	$("#address").addClass("pc-error-field");
	            	   $("#add_err_msg_address").show();
	            	   if(!name_error){
	            		   $("#add_err_msg_name").hide();   
	            	   } else {
	            		   $("#add_err_msg_name").show();
	            	   }
	            	   if(!city_error){
	            		   $("#add_err_msg_city").hide();  
	            	   } else {
	            		   $("#add_err_msg_city").show();
	            	   }
	            	    
	            	   regex_add_error = true;
	               }
	                if (!regex_name.test(city)) {
	                	city_error = true;
	                	$(".city-pty").addClass("pc-error-field");
	            	   $("#add_err_msg_city").show();
	            	   if(!address_error){
	            		   $("#add_err_msg_address").hide();
	            	   } else {
	            		   $("#add_err_msg_address").show();
	            	   }
	            	   if(!name_error){
	            		   $("#add_err_msg_name").hide();   
	            	   } else {
	            		   $("#add_err_msg_name").show();
	            	   }
	            	   regex_add_error = true;
	               }
	               if (!regex_name.test(zip)) {
	            	   city_error = true;
	            	   $(".zip-code-pty").addClass("pc-error-field");
	            	   $("#add_err_msg_city").show();
	            	   
	            	   if(!address_error){
	            		   $("#add_err_msg_address").hide();
	            	   } else {
	            		   $("#add_err_msg_address").show();
	            	   }
	            	   if(!name_error){
	            		   $("#add_err_msg_name").hide();   
	            	   } else {
	            		   $("#add_err_msg_name").show();
	            	   }
	            	    
	            	   regex_add_error = true;
	               }
	               
				if (regex_add_error) {
					orderCheckout.stepRunning = false;
					return;
				}*/
				
				var formData = orderCheckout._utils.getFormData(form);

				if (formData.saveInAddressBook) {
					orderCheckout._api.orderCheckout.saveShippingAddress(formData).then(function (res) {
						if (res && res.status == 200) {
							orderCheckout.updateShippingAddresses().then(function () {
								orderCheckout.shippingCollection.findItemByEntryNumber(formData.entryNo).selectNewestAddress("shippingAddress");
								orderCheckout.elements.addShippingModal.modal("hide");
							});
						}
					});
				} else {
					$("select[name='shippingId']").each(function( index ) 
					{
						orderCheckout.shippingCollection.findItemByEntryNumber(index).saveShippingAddress(formData);
						orderCheckout.elements.addShippingModal.modal("hide");
					});
				}

			},
			onThirdPartyAddressSubmit: function (form) {
				var hasErrors = orderCheckout._helpers.checkFormForErrors(form);
/*   				if (hasErrors) {
					orderCheckout._modals.error.show(orderCheckout._messages.formError);
					return;
				}   */

				var formData = orderCheckout._utils.getFormData(form);

				if (formData.saveInAddressBook) {
					orderCheckout._api.orderCheckout.saveThirdPartyAddress(formData).then(function (res) {
						if (res && res.status == 200) {
							orderCheckout.updateThirdPartyAddresses().then(function () {
								orderCheckout.shippingCollection.findItemByEntryNumber(formData.entryNo).selectNewestAddress("thirdParty");
								orderCheckout.elements.addThirdPartyModal.modal("hide");
							}).fail(function (e) {
							console.log(e);
							});
						} else {
							orderCheckout._modals.error.show(res.message);
						}
					});
				} else {
					orderCheckout.shippingCollection.findItemByEntryNumber(formData.entryNo).saveThirdPartyAddress(formData);
					orderCheckout.elements.addThirdPartyModal.modal("hide");
				}
			},
			onThirdPartyAddressRemove: function (addressId) {
				orderCheckout._api.orderCheckout.deleteThirdPartyAddress(addressId).then(function (res) {
					if (res && res.status == 200) {
						orderCheckout.context.thirdPartyAddresses = res.body.thirdPartyAddress;
						orderCheckout.renderThirdPartyAddresses();
					} else {
						orderCheckout._modals.error.show(res.message);
					}
				});
				// orderCheckout._modals.warning.show(orderCheckout._messages.underConstruction);
			},
			onGoToShipping: function (form) {
				if (orderCheckout.stepRunning) return;

				orderCheckout.stepRunning = true;
				orderCheckout.hideCartSizeWidget();
                var regex_error = false;
               var regex = /^[a-zA-Z0-9#\,. -]+$/;
               var customer_num = $(form).find("#customer-num").val();
                var len = customer_num.length;
        	   if(len > 30){
        		   regex_error = true;
            	   $("#customer-num").addClass("pc-error-field");
        		   $("#po_max_len_msg").show();
        		
        	   }else{
        		 $("#po_max_len_msg").hide();
            	 $("#customer-num").removeClass("pc-error-field");

        	   }
               if (!regex.test(customer_num)) {
            	   $("#customer-num").addClass("pc-error-field");
            	   regex_error = true; 
            	              	   $("#po_error_msg").show();
            	  
            	   
            	   
               }else{
            	   $("#po_error_msg").hide();
            	     $("#customer-num").removeClass("pc-error-field");
            	   
               }
				var hasErrors = orderCheckout._helpers.checkFormForErrors(form);
				if (hasErrors) {
					orderCheckout._modals.error.show(orderCheckout._messages.formError);
					orderCheckout.stepRunning = false;
					return;
				}
				if (regex_error) {
					
					//orderCheckout._modals.error.show(orderCheckout._messages.formError);
					orderCheckout.stepRunning = false;
					return;
				}
				var formData = orderCheckout._utils.getFormData(form);
				orderCheckout.firstStepData = {
					poNumber: formData.poNumber,
					orderNotes: formData.orderNotes,
				};

				orderCheckout._api.orderCheckout.setBillingAddress(formData.billingId).then(function (res) {
					if (res && res.status == 200) {

						orderCheckout.shippingCollection.setMinimalRequestTimeForEntries();

						orderCheckout.shippingCollection.updateExistingShippingInformation();

						orderCheckout.elements.goToShippingAcc.click();
					} else {
						orderCheckout._modals.error.show(res.message);
					}
				}).fail(function (res) {
					console.log(res);
				}).always(function () {
					orderCheckout.stepRunning = false;
				});
			},
			onGoToReview: function () {
				if (orderCheckout.stepRunning) return;
				
				var pk=$(document).find("[pc-container='order-checkout--item']").first().attr("pc-value");
				var sel = $("#" +pk).find( "select[name='shippingId']" ).val();
				var tex = $("#" +pk).find( "select[name='shippingId'] option:selected" ).text();
				$("select[name='shippingId']").each(function( index ) {
			         if ( $( this ).find('option:contains('+ tex +')').length <= 0 )       {//id = customAddress	
			        	 $( this ).append($('<option></option>').val("customAddress").html(tex));
			         }
				});
				localStorage.setItem("isGoToReview",true);
			  	$("select[name='shippingId']").val(sel).trigger("change");
                localStorage.setItem("isGoToReview",false);

				if($("#order-checkout--shipment-type-selector").val() == null)
				{
					$("#order-checkout--shipment-type-selector +span").addClass("pc-error-field");
					return;
				}
				orderCheckout.stepRunning = true;
				orderCheckout.hideCartSizeWidget();
				
				var defShip = orderCheckout.shippingCollection.saveEntriesShipping();

				defShip.then(function () {

					orderCheckout.globalData = orderCheckout.shippingCollection.getGlobalData();

					orderCheckout.globalData.purchaseOrderNumber = orderCheckout.firstStepData.poNumber;
					orderCheckout.globalData.orderNotes = orderCheckout.firstStepData.orderNotes;

					orderCheckout._api.orderCheckout.saveShippingDetails(orderCheckout.globalData).then(function (res) {
						if (res && res.status == 200) {

							orderCheckout.context.orderData = res.body.orderData;
							orderCheckout.context.reviewEntries = res.body.orderData.entries;
							orderCheckout.context.freightCharges=res.body.freightCharges;
							orderCheckout.reviewCollection.setCollection(orderCheckout.context.reviewEntries);

							orderCheckout.renderReviewStep();

							orderCheckout.elements.goToReviewAcc.click();
						} else {
							orderCheckout._modals.error.show(res.message);
							console.log(res);
						}
					}).fail(function (res) {
						console.log(res);
					});
				}).always(function () {
					orderCheckout.stepRunning = false;
				});
			},
			onGoToConfirm: function () {
				if (orderCheckout.stepRunning) return;

				if (!orderCheckout.checkIfTermsAndConditionsChecked()) return;

				orderCheckout.stepRunning = true;

				orderCheckout._api.orderCheckout.confirmCheckout(orderCheckout.globalData).then(function (res) {
					if (res && res.status == 200) {
						orderCheckout.context.order = res.body;
						orderCheckout.renderConfirmStep();
						orderCheckout.elements.saveOrderBtn.hide();
						orderCheckout.elements.cancelOrderBtn.hide();
						orderCheckout.elements.goToConfirmAcc.click();
						$(".referenceQuoteNumber").text("");

						orderCheckout._customerRating.showRatingModal();
						orderCheckout._cart.getCartItems();
						console.log("update minicart widget..");
						orderCheckout._cart.updateWidget(); 
						orderCheckout.showCartSizeWidget();
						orderCheckout._events.dispatchEvent("orderCreated");
						var cartData = orderCheckout.context.cartData;

						window.dataLayer = window.dataLayer || [];
						function gtag(){dataLayer.push(arguments);}
						
						var items = [];
						var entryItems = {}
						for(var index in cartData.entries)
						{ 
							entryItems = {
								"item_id" : cartData.entries[index].product.stockId,
								"item_name" : cartData.entries[index].product.code,
								"affiliation": "GEWOLONG Online store",
								"coupon" : "",
								"index" : index,
								"currency": cartData.deliveryCost.currencyIso,
								"item_category":cartData.entries[index].product.category,
								"quantity":cartData.entries[index].quantity,
								"price": cartData.entries[index].rmTotalPrice
							}
							items.push(entryItems)
						}
						var transaction_data = {
												"transaction_id": cartData.code,
												"affiliation": "GEWOLONG Online store",
												"value": cartData.rmTotalPrice,
												"currency": cartData.deliveryCost.currencyIso,
												"shipping":cartData.deliveryCost.value,
												"tax": cartData.totalTax.value,
												"items" : items,
												"coupon" : ""
												};
							
						gtag('js', new Date());
						gtag('config', orderCheckout._config.gaId);
						gtag('event', 'purchase', transaction_data);
						console.log(transaction_data);
						console.log(cartData);

					} else {
						orderCheckout._modals.error.show(res.body.errorDescription);
						console.log(res);
					}
				}).fail(function (res) {
					console.log(res);
				}).always(function () {
					orderCheckout.stepRunning = false;
				});
			}
		};

		orderCheckout.init = function () {

			return orderCheckout._cart.getCartItems().then(function () {

				if (!orderCheckout._cart.cartSize) {
					orderCheckout._goToPage("index");
					return;
				}
				
				orderCheckout.initCheckout().then(function (res) {

					if (res && res.status == 200) {
						$("body > div.modal-backdrop.fade.in").hide();
						orderCheckout.populateInitialContext().then(function () {

							orderCheckout._renderPageTemplate();

							orderCheckout._applyScript.base.accWizard();

							orderCheckout.shippingCollection.setCollection(orderCheckout.context.entries);

							orderCheckout._bindings();

							orderCheckout._helpers.populateCountries();
							orderCheckout._helpers.populateCountries("dropship");

							orderCheckout._helpers.updateCharCountdown();

							orderCheckout._events.dispatchEvent("controllerInitialized");

							orderCheckout._events.registerHandler("b2bUnitChanged", orderCheckout.name, orderCheckout.handlers.onB2bUnitChanged);
							
							orderCheckout.hideCartSizeWidget();

						});

					} else if (res && res.status == 406) {
							//$("body > div.modal-backdrop.fade.in").show();
							$('[pc-container="cart--item-kit-error'+res.body+'"]').show();
							window.history.replaceState({}, null, window.location.origin+"/rmstorefront/shopping-cart");
							app.router.writeHistory("push","/rmstorefront/shopping-cart", "");
							orderCheckout._cartCheckout.showForOrder();
					} 
					else 
					{
						window.history.replaceState({}, null, window.location.origin+"/rmstorefront/shopping-cart");
						app.router.writeHistory("push","/rmstorefront/shopping-cart", "");
						orderCheckout._modals.error.show(res.message);
					}
						
				});
			}).fail(function (e) {
				console.log(e);
			});

		};

		return orderCheckout;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});
